"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = require("lodash");
var base_1 = __importDefault(require("../crypto/base"));
// a mock storage class that just use js objects
// sql.js would be perfect for the job
var BitcoinLikeStorage = /** @class */ (function () {
    function BitcoinLikeStorage() {
        this.txs = [];
        // indexe: address + hash -> tx
        this.primaryIndex = {};
        // indexe: account + index -> tx
        this.accountIndex = {};
        // accounting
        this.unspentUtxos = {};
        this.addressCache = {};
        // only needed to handle the case when the input
        // is seen before the output (typically explorer
        // returning unordered tx within the same block)
        this.spentUtxos = {};
    }
    BitcoinLikeStorage.prototype.getLastTx = function (txFilter) {
        var _this = this;
        if (typeof this.accountIndex["".concat(txFilter.account, "-").concat(txFilter.index)] ===
            "undefined") {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var tx = (0, lodash_1.findLast)(this.accountIndex["".concat(txFilter.account, "-").concat(txFilter.index)].map(function (i) { return _this.txs[i]; }), function (t) {
            return (typeof txFilter.confirmed === "undefined" ||
                (txFilter.confirmed && t.block) ||
                (!txFilter.confirmed && !t.block));
        });
        return tx;
    };
    BitcoinLikeStorage.prototype.getLastUnconfirmedTx = function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var tx = (0, lodash_1.findLast)(this.txs, function (t) {
            return !t.block;
        });
        return tx;
    };
    BitcoinLikeStorage.prototype.getTx = function (address, txId) {
        var index = "".concat(address, "-").concat(txId);
        return this.txs[this.primaryIndex[index]];
    };
    // TODO: only expose unspentUtxos
    BitcoinLikeStorage.prototype.getAddressUnspentUtxos = function (address) {
        var indexAddress = address.address;
        return this.unspentUtxos[indexAddress];
    };
    BitcoinLikeStorage.prototype.appendTxs = function (txs) {
        var _this = this;
        var lastLength = this.txs.length;
        txs.forEach(function (tx) {
            var indexAddress = tx.address;
            var index = "".concat(indexAddress, "-").concat(tx.id);
            // we reject already seen tx
            if (_this.txs[_this.primaryIndex[index]]) {
                return;
            }
            if (typeof _this.accountIndex["".concat(tx.account, "-").concat(tx.index)] === "undefined") {
                _this.accountIndex["".concat(tx.account, "-").concat(tx.index)] = [];
            }
            var idx = _this.txs.push(tx) - 1;
            _this.primaryIndex[index] = idx;
            _this.accountIndex["".concat(tx.account, "-").concat(tx.index)].push(idx);
            _this.unspentUtxos[indexAddress] = _this.unspentUtxos[indexAddress] || [];
            _this.spentUtxos[indexAddress] = _this.spentUtxos[indexAddress] || [];
            tx.outputs.forEach(function (output) {
                if (output.address === tx.address) {
                    _this.unspentUtxos[indexAddress].push(output);
                }
            });
            tx.inputs.forEach(function (input) {
                if (input.address === tx.address) {
                    _this.spentUtxos[indexAddress].push(input);
                }
            });
            _this.unspentUtxos[indexAddress] = _this.unspentUtxos[indexAddress].filter(function (output) {
                var matchIndex = (0, lodash_1.findIndex)(_this.spentUtxos[indexAddress], function (input) {
                    return input.output_hash === output.output_hash &&
                        input.output_index === output.output_index;
                });
                if (matchIndex > -1) {
                    _this.spentUtxos[indexAddress].splice(matchIndex, 1);
                    return false;
                }
                return true;
            });
        });
        return this.txs.length - lastLength;
    };
    BitcoinLikeStorage.prototype.getUniquesAddresses = function (addressesFilter) {
        // TODO: to speed up, create more useful indexes in appendTxs
        return (0, lodash_1.uniqBy)(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        (0, lodash_1.filter)(this.txs, addressesFilter).map(function (tx) { return ({
            address: tx.address,
            account: tx.account,
            index: tx.index
        }); }), "address");
    };
    BitcoinLikeStorage.prototype.removeTxs = function (txsFilter) {
        var _this = this;
        var newTxs = [];
        this.primaryIndex = {};
        this.accountIndex = {};
        this.txs.forEach(function (tx) {
            // clean
            var indexAddress = tx.address;
            var index = "".concat(indexAddress, "-").concat(tx.id);
            if (tx.account !== txsFilter.account || tx.index !== txsFilter.index) {
                _this.primaryIndex[index] = newTxs.push(tx) - 1;
                return;
            }
            delete _this.unspentUtxos[indexAddress];
            delete _this.spentUtxos[indexAddress];
        });
        this.txs = newTxs;
        this.createAccountIndex();
    };
    // We are a bit ugly because we can't rely undo unspentUTXO
    // So we clean the address and rebuild without the pendings
    BitcoinLikeStorage.prototype.removePendingTxs = function (txsFilter) {
        var _this = this;
        var newTxs = [];
        var txsToReAdd = [];
        this.primaryIndex = {};
        this.accountIndex = {};
        this.txs.forEach(function (tx) {
            // clean
            var indexAddress = tx.address;
            var index = "".concat(indexAddress, "-").concat(tx.id);
            if (tx.account !== txsFilter.account || tx.index !== txsFilter.index) {
                _this.primaryIndex[index] = newTxs.push(tx) - 1;
                return;
            }
            if (tx.block) {
                txsToReAdd.push(tx);
            }
            delete _this.unspentUtxos[indexAddress];
            delete _this.spentUtxos[indexAddress];
        });
        this.txs = newTxs;
        this.createAccountIndex();
        this.appendTxs(txsToReAdd);
    };
    BitcoinLikeStorage.prototype.addAddress = function (key, address) {
        if (!this.addressCache) {
            this.addressCache = {};
        }
        this.addressCache[key] = address;
    };
    BitcoinLikeStorage.prototype.exportSync = function () {
        return {
            txs: this.txs,
            primaryIndex: this.primaryIndex,
            accountIndex: this.accountIndex,
            unspentUtxos: this.unspentUtxos,
            addressCache: this.addressCache
        };
    };
    BitcoinLikeStorage.prototype.loadSync = function (data) {
        this.txs = data.txs;
        this.primaryIndex = data.primaryIndex;
        this.accountIndex = data.accountIndex;
        this.unspentUtxos = data.unspentUtxos;
        this.addressCache = data.addressCache;
        base_1["default"].addressCache = __assign(__assign({}, base_1["default"].addressCache), this.addressCache);
        if (!this.accountIndex || (0, lodash_1.isEmpty)(this.accountIndex)) {
            this.accountIndex = {};
            this.createAccountIndex();
        }
    };
    BitcoinLikeStorage.prototype["export"] = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.exportSync()];
            });
        });
    };
    BitcoinLikeStorage.prototype.load = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.loadSync(data)];
            });
        });
    };
    BitcoinLikeStorage.prototype.createAccountIndex = function () {
        var _this = this;
        this.txs.forEach(function (tx, idx) {
            if (typeof _this.accountIndex["".concat(tx.account, "-").concat(tx.index)] === "undefined") {
                _this.accountIndex["".concat(tx.account, "-").concat(tx.index)] = [];
            }
            _this.accountIndex["".concat(tx.account, "-").concat(tx.index)].push(idx);
        });
    };
    return BitcoinLikeStorage;
}());
exports["default"] = BitcoinLikeStorage;
//# sourceMappingURL=index.js.map